import store from '@/store';

const globalMixin = {
  filters: {
    currency(value, currency = '£', returnNull = true) {
      if (value) {
        return `${currency}${parseFloat(parseInt(value) / 100).toFixed(2)}`;
      }

      return returnNull ? null : `${currency}0.00`;
    },

    time(value) {
      if (value?.includes(':')) {
        value = value
          .split(':')
          .slice(0, 2)
          .join(':');
      }

      return value;
    }
  },

  computed: {
    incidentStatus() {
      return this.$store.getters['IncidentStatus/all'];
    }
  },

  data() {
    return {
      perPage: 25
    };
  },

  methods: {
    getUser() {
      return this.$store.getters.user;
    },

    route(url) {
      this.$router.push(url);
    },

    hasModule(module) {
      if (this.$store.getters.user.modules) {
        return this.$store.getters.user.modules.indexOf(module) > -1;
      }
    },

    hasPermission(permission) {
      return this.$store.getters.user?.permissions?.indexOf(permission) > -1;
    },

    hasRole(role) {
      return this.$store.getters.user?.role === role;
    },

    isSolicitor() {
      return this.hasRole('solicitor');
    },

    isReadonly() {
      // Solicitor users have read-only access across the application.
      return this.isSolicitor();
    },

    penceToPounds(pence) {
      return parseFloat(parseInt(pence) / 100).toFixed(2);
    },

    poundsToPence(pounds) {
      return parseInt(pounds * 100);
    },

    getSetting(key) {
      if (
        this.$store.getters.user.settings &&
        this.$store.getters.user.settings.length
      ) {
        let setting = this.$store.getters.user.settings.find(setting => {
          return setting.key === key;
        });

        if (setting) {
          return setting.value;
        }

        return null;
      }
    },

    formatDate(dateTime, format = 'DD/MM/YYYY') {
      if (!dateTime) {
        console.warn('formatDate(): No date-time set');
        return null;
      }

      return window.DateManager.format(dateTime, format);
    },

    incidentUrl(incident) {
      let module = incident.stage?.name || '';
      let segment = module.replace(/_/g, '-');

      if (segment === 'hire-monitoring') {
        segment = 'claim-monitoring';
      }

      if (this.getIncidentStatusById(incident.status_id).name === 'rejected') {
        segment = 'rejected';
      }

      return `/${segment}/${incident.identifier}`;
    },

    getIncidentStatusById(id) {
      return this.incidentStatus.find(status => status.id === id);
    }
  }
};

export default globalMixin;
